import { render, staticRenderFns } from "./shebeilist.vue?vue&type=template&id=1b4f2d39&scoped=true&"
import script from "./shebeilist.vue?vue&type=script&lang=js&"
export * from "./shebeilist.vue?vue&type=script&lang=js&"
import style0 from "./shebeilist.vue?vue&type=style&index=0&id=1b4f2d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f2d39",
  null
  
)

export default component.exports